<template>
  <Layout>
    <!-- Header -->
    <div class="row">
      <div class="col-10">
        <PageHeader title="Video Speed Detection System Incidents" />
      </div>
      <div class="col-2">
        <button type="button" :class="isDataFilterActive
          ? 'btn btn-success toggle-vsds-filter w-100'
          : 'btn btn-primary toggle-vsds-filter w-100'
          " @click="toggleFilter">
          <span v-if="!isDataFilterActive"><i class="bx bx-cog bx-spin toggle-vsds-filter"></i> Select Filters
          </span>
          <span v-else><i class="bx bx-check toggle-vsds-filter mr-4"></i>Filters
            Applied</span>
        </button>
      </div>
    </div>
    <hr />
    <!-- Statistics -->
    <div class="row">
      <div class="col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">
                  {{
                  $t("menuitems.incident.list.vsds.list.totalSpeedViolation")
                  }}
                </p>
                <h5 class="mb-0" v-if="incidentStatistics.vsds">
                  {{ incidentStatistics.vsds.speedViolations }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-danger font-size-20">
                  <i class="bx bxs-car"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">
                  {{ $t("menuitems.incident.list.vsds.list.openViolations") }}
                </p>
                <h5 class="mb-0" v-if="incidentStatistics.vsds">
                  {{ incidentStatistics.vsds.openSpeedViolations }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-warning font-size-20">
                  <i class="bx bxs-folder-open"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">
                  {{
                  $t("menuitems.incident.list.vsds.list.resolvedViolations")
                  }}
                </p>
                <h5 class="mb-0" v-if="incidentStatistics.vsds">
                  {{ incidentStatistics.vsds.resolvedSpeedViolations }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-success font-size-20">
                  <i class="bx bxs-check-circle"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="card mini-stats-wid">
          <div class="card-body">
            <div class="d-flex flex-wrap">
              <div class="me-3">
                <p class="text-muted mb-2">
                  {{
                  $t("menuitems.incident.list.vsds.list.challansGenerated")
                  }}
                </p>
                <h5 class="mb-0" v-if="incidentStatistics.vsds">
                  {{ incidentStatistics.vsds.generatedSpeedViolationsChallan }}
                </h5>
              </div>

              <div class="avatar-sm ms-auto">
                <div class="avatar-title bg-light rounded-circle text-primary font-size-20">
                  <i class="bx bxs-file"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Incidents Table -->
    <Loader>
      <div class="table-responsive mb-0">
        <b-table class="datatables" :items="allIncidents" :fields="fields" responsive="sm" :per-page="0"
          :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :filter="filter"
          :filter-included-fields="filterOn" @filtered="onFiltered">
          <template #cell(vehicle_no)="row">
            {{ !row.item.vehicle_no ? "Unknown" : row.item.vehicle_no }}
          </template>

          <template #cell(status)="row">
            <span :class="`badge ${getStatusClass(row.item.status)}`">
              {{ getStatusText(row.item.status) }}
            </span>
          </template>

          <template #cell(challan_status)="row">
            <span :class="`badge ${getChallanStatusClass(row.item.challan_status)}`">{{
              getChallanStatusText(row.item.challan_status) }}</span>
          </template>

          <template #cell(veh_image_url)="row">
            <img v-if="row.item.veh_image_url !== 'NA'" :src="`${config.CLIENT_URL}${row.item.veh_image_url}`"
              width="80" @click="
                showImage(`${config.CLIENT_URL}${row.item.veh_image_url}`)
                " style="cursor: pointer" />
            <span v-else>Not Available</span>
          </template>

          <template #cell(actions)="row">
            <!-- <b-button size="sm" variant="primary" class="m-1" @click="showViewIncidentDetailsPage(row.item)">
              View Details
            </b-button> -->

            <!-- <button class="btn btn-sm btn-success m-2" @click="openResolveIncidentPage(row.item)"
              :disabled="row.item.status !== 'Open'">
              Resolve
            </button> -->
            <b-button variant="warning" class="m-1" size="sm" :id="`${row.item.id}-raise-challan-btn`"
              @click="showChallanDetails(row.item)" :disabled="row.item.challan_status === 'generated'">
              Raise Challan
            </b-button>
          </template>
        </b-table>
      </div>
      <div class="row">
        <div class="col">
          <div class="dataTables_paginate paging_simple_numbers float-end mb-3">
            <ul class="pagination pagination-rounded mb-0">
              <!-- pagination -->
              <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage"></b-pagination>
            </ul>
          </div>
        </div>
      </div>
    </Loader>

    <!-- Raise challan modal -->
    <b-modal id="raise-challan-modal" title="Raise Challan" title-class="font-18" size="xl" hide-footer centered>
      <template #modal-header>
        <div>
          <h5>Challan Details</h5>
        </div>
        <div>
          <button class="btn btn-sm btn-outline-danger" @click="$bvModal.hide('raise-challan-modal')">
            <i class="mdi mdi-close"></i>
          </button>
        </div>
      </template>

      <ChallanForm :incidentDetails="selectedIncident" @close="$bvModal.hide('raise-challan-modal')" />
    </b-modal>

    <!-- Quick image preview -->
    <vue-easy-lightbox :visible="showSingleImage" :imgs="selectedImage" :index="index"
      @hide="handleCaptionHide"></vue-easy-lightbox>

    <VsdsFilter :vehicleClassOptions="options.vehicleClass" @close="toggleFilter"
      @getFilteredIncidents="getFilteredIncidents" :packageFilterOptions="packageFilterOptions"
      @resetFilter="resetFilter" />
  </Layout>
</template>

<script>
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import RaiseNewIncident from "./raise-incident.vue";
import DatePicker from "vue2-datepicker";
import VueEasyLightbox from "vue-easy-lightbox";
import Swal from "sweetalert2";
import rpoMap from "../../views/incident/rpoVehicleMap.vue";
import incidentMixin from "../../mixins/incident";
import { mapActions } from "vuex";
import "../../assets/plugins/range-slider/vue-range-slider.css";
import VueRangeSlider from "../../assets/plugins/range-slider/vue-range-slider";
import Loader from "../../components/widgets/loader.vue";
import VsdsFilter from "@/components/incidents/vsds-filter";
import Config from "../../constants/config";
import ChallanForm from '@/components/incidents/challan-form'

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Incident Management",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },

  mixins: [incidentMixin],

  components: {
    Layout,
    PageHeader,
    RaiseNewIncident,
    VueEasyLightbox,
    rpoMap,
    DatePicker,
    VueRangeSlider,
    Loader,
    VsdsFilter,
    ChallanForm
  },

  data () {
    return {
      config: Config,
      selectedImage: null,
      showSingleImage: false,
      isDataFilterActive: false,
      speedFilter: [0, 500],
      currentChallanModalId: null,
      filterVehicleNumber: null,
      filterVehicleSpeed: 0,
      filterVehicleClass: null,
      datepickervalueFrom: null,
      datepickervalueTo: null,
      packageFilter: null,

      vehicleNumber: null,
      vehicleClass: null,
      allIncidents: [],
      packageFilterOptions: [],
      incidentId: null,
      visibleCaption: false,
      selectedIncident: {},
      resolveComment: "",
      index: 1,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      sortBy: "id",
      sortDesc: true,
      filterOn: [],
      filter: null,
      offenceId: 5554,
      dpCd: 'TP',
      latitude: null,
      voilationSource: null,
      stateCd: 'HR',
      districtId: 77,
      offCd: null,
      equipmentId: null,
      vendorName: null,
      vehicleSpeed: 0,
      speedLimit: null,
      vehicleWeight: null,
      voilationTime: null,
      actionTime: null,
      longitude: null,
      operatorId: null,

      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "plate_no",
          label: "Plate No.",
          sortable: false,
        },
        {
          key: "location",
          label: "Location IP",
          sortable: true,
          formatter: (value) => {
            return value ? value : "Unknown";
          },
        },
        {
          key: "class_id",
          label: "Veh. Class",
          sortable: false,
          formatter: (value) => {
            const obj = this.masters.vehicleClass.find((v) => v.id == value);
            return obj ? obj.class_name : "Unknown";
          },
        },
        {
          key: "vehicle_speed",
          label: "Speed",
          sortable: true,
          formatter: (value) => {
            return `${Math.round(value).toFixed(0)} km/hr`;
          },
        },
        {
          key: "class_confidence",
          label: "Confidence",
          sortable: false,
          formatter: (value) => {
            return `${(value * 100).toFixed(0)}%`;
          },
        },
        {
          key: "reported_datetime",
          label: "Timestamp",
          thStyle: { width: "10%" },
          sortable: true,
          formatter: (value) => {
            return this.getReadableDateTime(value);
          },
        },
        {
          key: "status",
          sortable: false,
        },
        {
          key: "challan_status",
          sortable: false,
        },
        {
          key: "veh_image_url",
          label: "Image",
          sortable: false,
          formatter: (value) => {
            return value ? value : "NA";
          },
        },
        {
          key: "actions",
          sortable: false,
          label: "Action",
        },
      ],

      options: {
        vehicleClass: [],
        offenceId: [],
        districtCode: [],
        stateCode: [],
        dpCd: [{ name: "TD" }, { name: "TR" }],
        violationSrc: [{ name: "SLV" }, { name: "RLV" }],
        subCategory: [],
        informedTo: [],
      },
      socketInterval: null,
    };
  },

  methods: {
    ...mapActions("incident", ["updateIncidents"]),
    showImage (imageUrl) {
      this.selectedImage = [imageUrl];
      this.showSingleImage = true;
    },
    getStatusText (status) {
      switch (status) {
        case "open":
          return "Open";

        case "in_progress":
          return "In Progress";

        case "resolved":
          return "Resolved";

        case "closed":
          return "Closed";

        default:
          return "Unknown";
      }
    },
    getStatusClass (status) {
      switch (status) {
        case "open":
          return "bg-danger";

        case "in_progress":
          return "bg-warning";

        case "resolved":
          return "bg-success";

        case "closed":
          return "bg-success";

        default:
          return "bg-info";
      }
    },

    getChallanStatusClass (status) {
      switch (status) {
        case "generated":
          return "bg-primary";

        case "not_generated":
          return "bg-danger";

        case "paid":
          return "bg-success";

        case "unpaid":
          return "bg-warning";

        case "approved":
          return "bg-info";

        default:
          return "bg-info";
      }
    },

    getChallanStatusText (status) {
      switch (status) {
        case "generated":
          return "Generated";

        case "not_generated":
          return "Not Generated";

        case "paid":
          return "Paid";

        case "unpaid":
          return "Unpaid";

        case "approved":
          return "Approved";

        default:
          return "Unknown";
      }
    },

    toggleFilter () {
      document.body.classList.toggle("vsds-right-bar-enabled");
    },

    challanGenerated () {
      Swal.fire(
        "Challan Generated",
        "Challan has been raised to this incident",
        "success"
      )
        .then(() => {
          this.offenceId = null;
          this.dpCd = null;
          this.voilationSource = null;
          this.stateCd = null;
          this.districtId = null;
          this.vehicleSpeed = 0;
          this.$bvModal.hide("raise-challan-modal");
        })
        .then(() => {
          this.openNextPossibleModalId();
        });
    },

    openNextPossibleModalId () {
      const int = setInterval(() => {
        const e = document.getElementById(
          `${this.currentChallanModalId - 1}-raise-challan-btn`
        );
        if (e) {
          clearInterval(int);
          e.click();
        } else {
          if (this.currentChallanModalId <= 0) {
            clearInterval(int);
            return;
          }
          this.currentChallanModalId -= 1;
        }
      }, 1);
    },

    incidentSaved () {
      Swal.fire(
        "Saved",
        "Incident details updated successfully",
        "success"
      ).then(() => {
        this.$bvModal.hide("more-details-modal");
        this.$bvModal.hide("raise-challan-modal");
      });
    },

    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getReadableDateTime (dateTime) {
      if (dateTime) {
        // const date = String(dateTime).split("T");
        return `${new Date(dateTime).toLocaleString()}`;
      }
    },


    showChallanDetails (incident) {
      if (incident.category_name !== "Accident") {
        this.selectedIncident = { ...incident, image_url: incident.veh_image_url, eventType: 'vsds', offenceId: 5554 };
        this.$bvModal.show("raise-challan-modal");
      }
    },

    handleCaptionHide () {
      this.visibleCaption = false;
      this.showSingleImage = false;
    },

    async getAllIncidents () {
      let fromDate = new Date(this.datepickervalueFrom);
      let toDate = new Date(this.datepickervalueTo);

      const result = await this.GetAllVsds({
        page: this.currentPage,
        incidentId: this.incidentId,
        filterVehicleNumber: this.filterVehicleNumber,
        fromDate: fromDate.toISOString(),
        toDate: toDate.toISOString(),
        eventCategory: null,
        vehicleClass: this.vehicleClass,
        minSpeed: this.speedFilter[0],
        maxSpeed: this.speedFilter[1],
        packageFilter: this.packageFilter,
      });

      this.perPage = result.rows;
      this.totalRows = result.totalPageNumber;
      this.allIncidents = result.data;
    },

    async getIncidentMasters () {
      try {
        const incidents = await this.GetIncidentMasters();
        this.options.vehicleClass = incidents.getVehicleClass;
        this.options.offenceId = incidents.getOffenceId;
        this.options.districtCode = incidents.getDistrictCode;
        this.options.stateCode = incidents.getStateCode;
        this.options.subCategory = incidents.getIncidentSubCategory;
        this.options.informedTo = incidents.rpoData;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
        Swal.fire(
          "Network Error",
          "Failed to fetch data from the server. Please check your internet connection.",
          "error"
        );
      }
    },

    async getFilteredIncidents (e) {
      const data = JSON.parse(e);
      let fromDate = new Date(data.datepickervalueFrom);
      let toDate = new Date(data.datepickervalueTo);

      if (
        fromDate.toISOString().includes("1970-01-01") &&
        toDate.toISOString().includes("1970-01-01") &&
        !data.incidentId &&
        !data.filterVehicleNumber &&
        !data.vehicleClass &&
        !data.packageFilter &&
        data.speedFilter[0] === 0 &&
        data.speedFilter[1] === 500
      ) {
        this.$toast.warning("Please select filter options", {
          position: "top-left",
          duration: 3000,
        });
        // Swal.fire("Please select filter options", "", "warning");
        return;
      }

      toDate.setHours(23, 59, 59, 999);

      this.isDataFilterActive = true;
      this.$store.dispatch("layout/changeLoaderValue", true);
      this.toggleFilter();
      const result = await this.GetAllVsds({
        page: this.currentPage,
        incidentId: data.incidentId,
        filterVehicleNumber: data.filterVehicleNumber,
        fromDate: fromDate.toISOString(),
        toDate: toDate.toISOString(),
        eventCategory: null,
        vehicleClass: data.vehicleClass,
        minSpeed: data.speedFilter[0],
        maxSpeed: data.speedFilter[1],
        locationIp: data.packageFilter,
      });

      this.perPage = result.rows;
      this.totalRows = result.totalPageNumber;
      this.allIncidents = result.data;
      this.$store.dispatch("layout/changeLoaderValue", false);
    },

    resetFilter () {
      this.isDataFilterActive = false;
      this.packageFilter = null;
      this.toggleFilter();
    },
  },

  computed: {
    masters () {
      return this.$store.getters["incident/masters"];
    },
    incidentStatistics () {
      return this.$store.getters["socket/incident"].statistics;
    },
    incidents () {
      return this.$store.getters["socket/incident"].vsdsIncidents;
    },
    currentUser () {
      return this.$store.getters["auth/user"];
    },
  },

  async mounted () {
    await this.getIncidentMasters();

    this.operatorId = this.currentUser.user.id;

    this.sockets.subscribe("GET_INCIDENT_BY_ID", (data) => {
      this.allIncidents = data;
    });

    const filtersData = await this.GetVsdsFiltersData();

    // Locations Filter
    for (let locationIp of filtersData.locationsIp) {
      if (locationIp) this.packageFilterOptions.push({ location: locationIp });
    }

    this.socketInterval = setInterval(() => {
      if (!this.isDataFilterActive) {
        this.$socket.emit("REQUEST:VSDS_INCIDENTS_STATS");

        if (this.currentPage == 1) {
          this.$socket.emit("REQUEST:VSDS_DATA");
        }
      }
    }, 30000);

    this.$socket.emit("REQUEST:VSDS_INCIDENTS_STATS");
    this.$socket.emit("REQUEST:VSDS_DATA");

    this.$store.dispatch("layout/changeLoaderValue", false);
  },

  watch: {
    currentPage: async function () {
      await this.getAllIncidents();
    },
    incidents: async function () {
      this.allIncidents = this.incidents.data;
      this.perPage = this.incidents.rows;
      this.totalRows = this.incidents.totalPageNumber;
    },
  },

  beforeDestroy () {
    if (this.socketInterval) {
      clearInterval(this.socketInterval);
      this.socketInterval = null;
    }
  },
};
</script>

<style scoped>
.image {
  height: 100px;
  cursor: pointer;
  margin: 5px;
  display: inline-block;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
